var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobalView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_139_1",
    "data-name": "Component 139 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.354,
    height: 28.27,
    viewBox: "0 0 44.354 28.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M44.073,106.107c-.4-.542-9.837-13.272-21.9-13.272s-21.5,12.73-21.9,13.272a1.464,1.464,0,0,0,0,1.726c.4.542,9.837,13.272,21.9,13.272s21.5-12.73,21.9-13.272A1.462,1.462,0,0,0,44.073,106.107Zm-21.9,12.073c-8.882,0-16.575-8.449-18.852-11.211C5.6,104.2,13.276,95.759,22.177,95.759c8.882,0,16.574,8.448,18.852,11.211C38.755,109.735,31.078,118.18,22.177,118.18Z",
    transform: "translate(0 -92.835)",
    fill: "#fff"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "internet",
    transform: "translate(15.281 7.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M231.816,347c1.026-.146,1.925-1.216,2.49-2.8a12.173,12.173,0,0,0-2.49-.293Zm0,0",
    transform: "translate(-224.871 -333.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M279.706,360.041c.061-.018.121-.035.181-.055s.1-.034.15-.051.118-.041.176-.064l.149-.059.171-.072.147-.067c.055-.026.11-.053.165-.08l.144-.075.16-.088.141-.082.155-.1c.046-.029.092-.059.137-.09s.1-.07.15-.1l.132-.1.145-.114c.043-.034.085-.068.127-.1s.094-.081.14-.122.082-.072.122-.109.09-.087.135-.131.078-.076.116-.115l.021-.023a8.055,8.055,0,0,0-1.642-.632A5.948,5.948,0,0,1,279.5,360.1l.058-.014Zm0,0",
    transform: "translate(-271.123 -346.909)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M338.916,231.684h-2.874a12.426,12.426,0,0,1-.484,3.316,8.338,8.338,0,0,1,1.819.724A6.7,6.7,0,0,0,338.916,231.684Zm0,0",
    transform: "translate(-325.505 -224.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M231.816,112.139h3.113a11.99,11.99,0,0,0-.472-3.2,12.624,12.624,0,0,1-2.641.315Zm0,0",
    transform: "translate(-224.871 -105.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M231.816.316v3.09a12.181,12.181,0,0,0,2.49-.293C233.741,1.532,232.842.462,231.816.316Zm0,0",
    transform: "translate(-224.871 -0.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M231.816,234.567a12.634,12.634,0,0,1,2.641.315,11.991,11.991,0,0,0,.472-3.2h-3.113Zm0,0",
    transform: "translate(-224.871 -224.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M337.378,80.844a8.337,8.337,0,0,1-1.819.724,12.426,12.426,0,0,1,.484,3.316h2.874A6.7,6.7,0,0,0,337.378,80.844Zm0,0",
    transform: "translate(-325.505 -78.431)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M282.633,8.652l-.021-.022c-.038-.039-.077-.077-.116-.115s-.089-.088-.135-.131-.081-.072-.121-.109-.093-.083-.141-.123-.084-.068-.126-.1-.1-.077-.146-.115-.087-.064-.131-.1-.1-.072-.151-.106l-.136-.089c-.052-.033-.1-.066-.156-.1l-.14-.082-.161-.089-.144-.074c-.055-.028-.111-.055-.168-.081l-.146-.067c-.057-.025-.114-.048-.171-.072l-.148-.059c-.058-.022-.117-.043-.176-.063l-.15-.051c-.06-.019-.12-.037-.181-.055s-.1-.029-.15-.043l-.058-.014a5.948,5.948,0,0,1,1.532,2.487A8.043,8.043,0,0,0,282.633,8.652Zm0,0",
    transform: "translate(-271.085 -6.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M0,84.883H2.874a12.434,12.434,0,0,1,.484-3.316,8.326,8.326,0,0,1-1.819-.724A6.7,6.7,0,0,0,0,84.883Zm0,0",
    transform: "translate(0 -78.431)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M135.186,347v-3.09a12.181,12.181,0,0,0-2.49.293C133.261,345.788,134.16,346.858,135.186,347Zm0,0",
    transform: "translate(-128.72 -333.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M115.034,231.684h-3.113a11.986,11.986,0,0,0,.472,3.2,12.617,12.617,0,0,1,2.641-.315Zm0,0",
    transform: "translate(-108.569 -224.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M135.186.316c-1.026.146-1.925,1.216-2.49,2.8a12.165,12.165,0,0,0,2.49.293Zm0,0",
    transform: "translate(-128.72 -0.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M115.034,109.256a12.624,12.624,0,0,1-2.641-.315,11.985,11.985,0,0,0-.472,3.2h3.113Zm0,0",
    transform: "translate(-108.569 -105.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M65.365,6.789l-.058.014-.151.043-.18.054-.151.051c-.059.021-.117.041-.175.063l-.149.059-.17.072-.147.067c-.055.026-.11.053-.165.08l-.144.075-.16.088q-.072.04-.141.082l-.155.1-.137.09c-.051.034-.1.07-.15.1l-.133.1c-.049.037-.1.075-.145.114s-.086.068-.127.1-.094.081-.14.121-.082.072-.122.11-.09.087-.134.13-.078.076-.116.115l-.021.023a8.046,8.046,0,0,0,1.642.632A5.945,5.945,0,0,1,65.365,6.789Zm0,0",
    transform: "translate(-60.328 -6.595)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M62.365,358.332c.045.044.089.088.135.131s.081.072.122.109.093.083.141.122.084.068.126.1.1.077.147.115l.131.1c.05.036.1.072.152.106l.136.089c.052.033.1.066.156.1l.14.082q.08.046.161.089l.144.074c.055.028.111.055.168.081l.146.067c.057.025.114.048.171.072l.148.059c.058.022.117.043.176.064l.15.051c.06.019.12.037.181.055l.15.043.059.014a5.949,5.949,0,0,1-1.532-2.487,8.045,8.045,0,0,0-1.642.632l.021.022C62.287,358.256,62.326,358.294,62.365,358.332Zm0,0",
    transform: "translate(-60.366 -346.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M1.539,235.723A8.339,8.339,0,0,1,3.358,235a12.434,12.434,0,0,1-.484-3.316H0A6.7,6.7,0,0,0,1.539,235.723Zm0,0",
    transform: "translate(0 -224.752)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalView);
export default __webpack_public_path__ + "static/media/global_view.5315248b483b2f06b5b0d4084b031090.svg";
export { ForwardRef as ReactComponent };